import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChevronRightDouble = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.70718 7.29297L11.7072 11.293C12.0977 11.6835 12.0977 12.3167 11.7072 12.7072L7.70718 16.7072L6.29297 15.293L9.58586 12.0001L6.29297 8.70718L7.70718 7.29297ZM14.7072 7.29297L18.7072 11.293C19.0977 11.6835 19.0977 12.3167 18.7072 12.7072L14.7072 16.7072L13.293 15.293L16.5859 12.0001L13.293 8.70718L14.7072 7.29297Z"
        />
      </svg>
    );
  }
);
